import moment from "moment-timezone";

const WORDS_PER_MINUTE = 200;

export const formatArticleDate = (iso?: string) => {
  if (!iso) return null;
  const date = moment.utc(iso);
  return date.isValid() ? date.format("MMMM D, YYYY") : null;
};

// Collects every `text` string from a Storyblok richtext document.
const collectText = (node: any): string[] => {
  if (!node || typeof node !== "object") return [];
  const own = typeof node.text === "string" ? [node.text] : [];
  const children = Array.isArray(node.content)
    ? node.content.flatMap(collectText)
    : [];
  return [...own, ...children];
};

// Approximate reading time (minutes) from the article's text components.
export const getReadingMinutes = (body?: any[]) => {
  const text = (body ?? [])
    .filter((blok) => blok?.component === "text_component")
    .flatMap((blok) => [
      ...collectText(blok.title),
      ...collectText(blok.content),
    ])
    .join(" ");
  const words = text.split(/\s+/).filter(Boolean).length;
  return words ? Math.max(1, Math.ceil(words / WORDS_PER_MINUTE)) : null;
};
